import React from 'react';
import './LoadingPage.css';
import { useTranslation } from 'react-i18next';

const LoadingPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="loading-page">
      {/* Background with floating shapes */}
      <div className="loading-background">
        <div className="loading-shapes">
          <div className="loading-shape loading-shape-1"></div>
          <div className="loading-shape loading-shape-2"></div>
          <div className="loading-shape loading-shape-3"></div>
          <div className="loading-shape loading-shape-4"></div>
        </div>
        
        {/* Gradient orbs */}
        <div className="loading-orbs">
          <div className="loading-orb loading-orb-1"></div>
          <div className="loading-orb loading-orb-2"></div>
          <div className="loading-orb loading-orb-3"></div>
        </div>
      </div>

      {/* Main loading content */}
      <div className="loading-content">
        {/* Mystical card with loading animation */}
        <div className="loading-card">
          <div className="loading-card-content">
            {/* Pulsing crystal/sparkle */}
            <div className="loading-crystal">
              <div className="crystal-sparkle crystal-sparkle-1"></div>
              <div className="crystal-sparkle crystal-sparkle-2"></div>
              <div className="crystal-sparkle crystal-sparkle-3"></div>
              <div className="crystal-core"></div>
            </div>
            
            {/* Loading text */}
            <div className="loading-text">
              <h2 className="loading-title">{t("loadingTitle", "Loading Magic...")}</h2>
              <p className="loading-subtitle">{t("loadingSubtitle", "Preparing your mystical journey")}</p>
            </div>
            
            {/* Animated dots */}
            <div className="loading-dots">
              <div className="loading-dot"></div>
              <div className="loading-dot"></div>
              <div className="loading-dot"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingPage;
